module.exports = __webpack_public_path__ + "img/demi.71a210c.webp";